import React, { useState, useRef } from 'react'
import Cropper from 'react-cropper'
import 'cropperjs/dist/cropper.css'
import { Button } from '../Button'
import { toast } from 'react-toastify'

interface uploadImageProps {
  uploadImage: (id?: string, image: string, successCallback: () => void) => void
}

export default function CropperComponent({ id, uploadImage, successCallback }: uploadImageProps) {
  const [selectedImage, setImage] = useState<string>('')
  const [croppedImage, setCroppedImage] = useState<string>('')
  const cropperRef = useRef<HTMLImageElement>(null)
  const inputRef = useRef<HTMLInputElement>(null)

  const onDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault()
    const files = event.dataTransfer.files
    if (files && files.length > 0) {
      const file = files[0]
      const reader = new FileReader()
      reader.onload = () => {
        setImage(reader.result as string)
      }
      reader.readAsDataURL(file)
    }
  }

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files
    if (files && files.length > 0) {
      const file = files[0]
      const reader = new FileReader()
      reader.onload = () => {
        setImage(reader.result as string)
      }
      reader.readAsDataURL(file)
    }
  }

  const onDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault()
  }

  const triggerFileSelectPopup = () => inputRef.current?.click()

  const cropImage = () => {
    if (cropperRef.current?.cropper) {
      const canvas = cropperRef.current.cropper.getCroppedCanvas()
      if (canvas) {
        const croppedImage = canvas.toDataURL()
        setCroppedImage(croppedImage)
      }
    }
  }

  const deleteImage = () => {
    setCroppedImage('')
    setImage('')
  }

  const saveImage = async () => {
    const res = await uploadImage(id, croppedImage);
    if (res?.status === 200) {
      toast.success('Image uploaded successfully')
      successCallback(croppedImage)
    } else {
      toast.error('Failed to upload image')
    }
  }

  return (
    <div className="mt-6">
      {!selectedImage && (
        <div
          className="flex h-52 w-full cursor-pointer items-center justify-center rounded-lg border-2 border-dashed border-gray-200 text-center"
          onDrop={onDrop}
          onDragOver={onDragOver}
          onClick={triggerFileSelectPopup}
        >
          Select image to upload or drag & drop the image
          <input
            type="file"
            accept="image/*"
            onChange={onChange}
            ref={inputRef}
            className="hidden"
          />
        </div>
      )}
      {selectedImage && (
        <div>
          {!croppedImage && (
            <Cropper
              src={selectedImage}
              style={{ height: 400, width: '100%' }}
              initialAspectRatio={1 / 1}
              aspectRatio={1 / 1}
              guides={true}
              viewMode={2}
              ref={cropperRef}
              className="mb-6"
              // You can add more props to customize your Cropper
            />
          )}

          {croppedImage && (
            <div className="mb-6 rounded-lg">
              <img src={croppedImage} className="h-full w-full rounded-lg" />
            </div>
          )}

          <div className="flex justify-between">
            <Button
              type="button"
              onClick={() => deleteImage()}
              text="Delete"
              className="mr-2 w-full border-[1px] border-[#676b5f] bg-transparent shadow-none hover:bg-white"
            />

            {!croppedImage && (
              <Button
                type="button"
                onClick={cropImage}
                text="Crop"
                className="ml-2 w-full text-white"
              />
            )}

            {croppedImage && (
              <Button
                type="button"
                onClick={saveImage}
                text="Upload"
                className="ml-2 w-full text-white"
              />
            )}
          </div>
        </div>
      )}
    </div>
  )
}
